export const WORKSPACE_NAME_MIN_LENGTH = 3;
export const WORKSPACE_NAME_MAX_LENGTH = 21;

const workspaceLoginIdPattern = /^[a-z][a-z0-9-]*[a-z0-9]$/;

export const isWorkspaceLoginIdValid = (workspaceLoginId: string): boolean =>
  workspaceLoginIdPattern.test(workspaceLoginId) &&
  workspaceLoginId.length >= WORKSPACE_NAME_MIN_LENGTH &&
  workspaceLoginId.length <= WORKSPACE_NAME_MAX_LENGTH;
